import { TmFormError } from '@/core/error/tmFormError'

export class TmFormBuilderInitError extends TmFormError {
  public name = 'TmFormBuilderInitError'

  protected isMonitored = false
}
